module.exports = __webpack_public_path__ + "static/einkaufswagen-eea5a532166781fb540e6ce366520aab.png";